import {
  Glass,
  PillChip,
  Dot,
  BodyText,
  DisplayText,
  alpha,
  borderAlpha,
} from "../../components/mobile/primitives";

function SkillCard({ accent, title, creator, tagline, rating, installs, tapped }) {
  return (
    <Glass
      style={{
        padding: "10px 12px",
        display: "flex",
        alignItems: "flex-start",
        gap: 10,
        border: tapped ? borderAlpha(accent, "50") : "1px solid rgba(255,255,255,0.35)",
        background: tapped
          ? `linear-gradient(135deg, ${alpha(accent, "08")}, ${alpha(accent, "04")})`
          : "rgba(254,253,250,0.58)",
      }}
    >
      <Dot color={accent} size={9} style={{ marginTop: 4 }} />
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: "flex", alignItems: "baseline", gap: 5 }}>
          <BodyText size={10.5} weight={700} color="var(--color-kin-black)">
            {title}
          </BodyText>
          <BodyText size={8} color="var(--color-kin-muted)" weight={500}>
            {creator}
          </BodyText>
        </div>
        <BodyText
          size={8.5}
          color="var(--color-kin-muted)"
          weight={400}
          style={{ marginTop: 2, lineHeight: 1.4 }}
        >
          {tagline}
        </BodyText>
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 5 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 3 }}>
            <svg width="9" height="9" viewBox="0 0 12 12" fill={accent} opacity={0.8}>
              <polygon points="6,0.5 7.5,4.2 11.5,4.5 8.5,7 9.4,11 6,9 2.6,11 3.5,7 0.5,4.5 4.5,4.2" />
            </svg>
            <BodyText size={8} color="var(--color-kin-muted)" weight={600}>
              {rating}
            </BodyText>
          </div>
          <BodyText size={7.5} color="var(--color-kin-muted)" weight={500}>
            {installs} installs
          </BodyText>
        </div>
      </div>
    </Glass>
  );
}

export function JourneyMarketplaceBrowseScreen() {
  const categories = [
    { label: "All", active: true },
    { label: "Sleep", active: false },
    { label: "Labs", active: false },
    { label: "Nutrition", active: false },
    { label: "Fitness", active: false },
  ];

  const skills = [
    {
      accent: "var(--color-kin-rose)",
      title: "Cardio Fitness",
      creator: "Dr. Sara Chen",
      tagline: "VO2 trends, resting HR, and workout intensity tracking",
      rating: "4.8",
      installs: "2.1k",
      tapped: true,
    },
    {
      accent: "var(--color-kin-lavender)",
      title: "Sleep Deep Dive",
      creator: "Dr. Sara Chen",
      tagline: "Sleep stages, HRV trends, and recovery patterns",
      rating: "4.9",
      installs: "3.4k",
      tapped: false,
    },
    {
      accent: "var(--color-kin-green-soft)",
      title: "Lab Panel Review",
      creator: "Jonas Weber",
      tagline: "Blood panel interpretation with trend tracking",
      rating: "4.7",
      installs: "1.8k",
      tapped: false,
    },
    {
      accent: "var(--color-kin-orange)",
      title: "Nutrition Audit",
      creator: "Jonas Weber",
      tagline: "Meal patterns and macro balance analysis",
      rating: "4.6",
      installs: "1.2k",
      tapped: false,
    },
    {
      accent: "var(--color-kin-green-mid)",
      title: "Recovery Score",
      creator: "Lisa Park",
      tagline: "Daily readiness from sleep, HRV, and training load",
      rating: "4.5",
      installs: "890",
      tapped: false,
    },
  ];

  return (
    <div
      style={{
        padding: "14px 16px 0",
        display: "flex",
        flexDirection: "column",
        gap: 10,
        height: "100%",
        position: "relative",
      }}
    >
      <DisplayText size={20}>Explore</DisplayText>

      {/* Search bar */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          padding: "8px 12px",
          borderRadius: 12,
          background: "rgba(0,0,0,0.04)",
          border: "1px solid rgba(0,0,0,0.06)",
        }}
      >
        <svg
          width="13"
          height="13"
          viewBox="0 0 24 24"
          fill="none"
          stroke="var(--color-kin-muted)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="11" cy="11" r="8" />
          <path d="M21 21l-4.35-4.35" />
        </svg>
        <BodyText size={9.5} color="var(--color-kin-muted)" weight={400}>
          Search skills…
        </BodyText>
      </div>

      {/* Category pills */}
      <div style={{ display: "flex", gap: 6, overflowX: "auto" }}>
        {categories.map((cat) => (
          <PillChip key={cat.label} active={cat.active} color="var(--color-kin-pink)">
            {cat.label}
          </PillChip>
        ))}
      </div>

      {/* Skill cards */}
      <div style={{ display: "flex", flexDirection: "column", gap: 6, flex: 1 }}>
        {skills.map((skill) => (
          <SkillCard key={skill.title} {...skill} />
        ))}
      </div>
    </div>
  );
}
